import _ from 'lodash';

import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {CustomViewModel} from '../../../models/api/customViewModel';
import {ApiTag} from '../../../models/api/tagModel';
import {fetchApiAsync} from '../../../services/http/http';
import {ThunkAction, ThunkAsyncAction} from '../../appThunk';
import {updateDataAction} from '../dataGroupsActions';

/*
 * Action types.
 */

export enum CustomViewsActionsEnum {
  SET_CUSTOM_VIEWS = '@@data/customViews/SET_CUSTOM_VIEWS',
}

/*
 * Types.
 */

export interface SetCustomViewsAction extends ActionWithPayload<ReadonlyArray<CustomViewModel>> {
  type: CustomViewsActionsEnum.SET_CUSTOM_VIEWS;
}

/*
 * Action creators.
 */

export function setCustomViews(customViews: ReadonlyArray<CustomViewModel>): ThunkAction {
  return async (dispatch, getState) => {
    // Update the custom views in the state.
    const action: SetCustomViewsAction = {
      type: CustomViewsActionsEnum.SET_CUSTOM_VIEWS,
      payload: customViews,
    };
    dispatch(action);

    // Find if we're missing tags.
    const {tags} = getState().data;
    const missingTagIds = _(customViews)
      .filter((c) => !tags[c.id])
      .map((c) => c.id)
      .value();

    // Fetch the missing tags and add to the state.
    return dispatch(fetchTagsAction(missingTagIds));
  };
}

export function fetchTagsAction(tagIds: ReadonlyArray<number>): ThunkAsyncAction {
  return async (dispatch, getState) => {
    // Fetch the tags.
    const {company} = getState().data;
    const fetchPromises = tagIds.map(async (id) => {
      const url = `${company.url}/tags/${id}`;
      return fetchApiAsync(ApiTag, url);
    });

    // Update the state.
    const tags = await Promise.all(fetchPromises);
    dispatch(updateDataAction({tags}));
  };
}

/*
 * Union type.
 */

export type CustomViewsAction = SetCustomViewsAction;
